module.exports = __webpack_public_path__ + "media/images/ln/horoscope_4-c9e8ee2130e885bdb06d5b81b903b079.png";